
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'BuyersManagementHeader'
})
export default class extends Vue {
}
